(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("consortium-contrato", {
                parent: "entity",
                url: "/consortium-contrato?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato.html",
                        controller: "ConsortiumContratoController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("consortium-contrato.new", {
                parent: "consortium-contrato",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN"],
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato-new.html",
                        controller: "ConsortiumContratoNewController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Nuevo",
                    parent: "consortium-contrato",
                },
                resolve: {
                    entity: function () {
                        return {
                            id: null,
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contrato",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            })
            .state("consortium-contrato.edit", {
                parent: "consortium-contrato",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_CONSORTIUM"],
                    pageTitle: "ConsortiumContrato",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/consortium-contrato/consortium-contrato-detail.html",
                        controller: "ConsortiumContratoDetailController",
                        controllerAs: "vm",
                    },
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "consortium-contrato",
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "ConsortiumContrato",
                        function ($stateParams, ConsortiumContrato) {
                            return ConsortiumContrato.get({
                                id: $stateParams.id,
                            }).$promise;
                        },
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name:
                                    $state.current.name ||
                                    "consortium-contrato",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                ),
                            };
                            return currentStateData;
                        },
                    ],
                },
            });
    }
})();
